import { render, staticRenderFns } from "./hukou.vue?vue&type=template&id=b57cfb46&scoped=true&"
import script from "./hukou.vue?vue&type=script&lang=js&"
export * from "./hukou.vue?vue&type=script&lang=js&"
import style0 from "./hukou.vue?vue&type=style&index=0&id=b57cfb46&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b57cfb46",
  null
  
)

export default component.exports